import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Form, Card, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from '../LoadingOverlay';

function PropertyKeyContact(props) {
  const [editing, setEditing] = useState(false);

  return (
    <Row>
      <Col>
        {editing ? (
          <Formik
            initialValues={{
              users: props.users,
              name: props.propertyKeyContact.name,
              email: props.propertyKeyContact.email,
              phone_number: props.propertyKeyContact.phone_number
            }}
            validate={(values) => {
              const errors = {};

              let phoneNumberValid = false;
              const numberWithCountryCode = /^[\+]?[(]?[0-9]{2}[)]?[-\s]?[0-9]{2}[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/;
              const numberWithPrefix = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4}$/;

              if (
                values.phone_number.match(numberWithCountryCode) ||
                values.phone_number.match(numberWithPrefix)
              ) {
                phoneNumberValid = true;
              }

              if (!values.name) {
                errors.name = 'Name is required';
              } else if (!values.email) {
                errors.email = 'Email is required';
              } else if (
                !values.phone_number ||
                phoneNumberValid === false ||
                isNaN(values.phone_number.replace(/\D/g, ''))
              ) {
                errors.phone_number = 'Phone number is required';
              }
              return errors;
            }}
            onSubmit={(values, actions) => {
              const body = {
                name: values.name,
                email: values.email,
                phone_number: values.phone_number
              };
              fetch(
                `${process.env.REACT_APP_PROPERTIES_API_URL}api/property-key-contacts/${props.propertyKeyContact.id}`,
                {
                  method: 'PUT',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${props.bearerToken}`,
                    SeasonalDatabase: props.selectedDatabase
                  },
                  body: JSON.stringify(body)
                }
              )
                .then((res) => {
                  if (res.ok) {
                    return res.json();
                  } else if (res.status === 401) {
                    props.refreshBearerToken();
                  } else {
                    throw Error(res.statusText);
                  }
                })
                .then((data) => {
                  if (data) {
                    props.update(data);
                  }
                })
                .catch((err) => {
                  if (process.env.NODE_ENV === 'development')
                    console.error(err);
                  actions.setSubmitting(false);
                })
                .finally(() => setEditing(false));
            }}
          >
            {(props) => (
              <Card>
                <Card.Header className='d-flex justify-content-between align-items-center'>
                  <h3>Details</h3>
                  <div>
                    <Button
                      variant='link'
                      className='text-success'
                      type='button'
                      onClick={props.submitForm}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <Button
                      variant='link'
                      className='text-danger'
                      type='button'
                      onClick={() => setEditing(false)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={props.handleSubmit}>
                    <Form.Group controlId='name'>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type='text'
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.name}
                        placeholder='Name'
                        isInvalid={props.errors.name}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {props.errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId='email'>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type='text'
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.email}
                        placeholder='Email'
                        isInvalid={props.errors.email}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {props.errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId='phone_number'>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type='text'
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.phone_number}
                        placeholder='Phone Number'
                        isInvalid={props.errors.phone_number}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {props.errors.phone_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                    {props.isSubmitting ? <LoadingOverlay /> : null}
                  </Form>
                </Card.Body>
              </Card>
            )}
          </Formik>
        ) : (
          <>
            <div className='mb-2'>
              <Button variant='outline-secondary' onClick={props.close}>
                Back
              </Button>
            </div>

            <Card>
              <Card.Header className='d-flex justify-content-between align-items-center'>
                <h3>Details</h3>
                <Button
                  variant='link'
                  type='button'
                  onClick={() => setEditing(true)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
              </Card.Header>
              <Card.Body>
                <Fragment>
                  <Row>
                    <Col>Name</Col>
                    <Col>{props.propertyKeyContact.name}</Col>
                  </Row>
                  <Row>
                    <Col>Email</Col>
                    <Col>{props.propertyKeyContact.email}</Col>
                  </Row>
                  <Row>
                    <Col>Phone Number</Col>
                    <Col>{props.propertyKeyContact.phone_number}</Col>
                  </Row>
                </Fragment>
              </Card.Body>
            </Card>
          </>
        )}
      </Col>
    </Row>
  );
}

PropertyKeyContact.propTypes = {
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  selectedDatabase: PropTypes.string.isRequired,
  propertyKeyContact: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  update: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default PropertyKeyContact;
